module.exports = __webpack_public_path__ + "static/bg05-0b26e04225c7ff7c1660b46ee2b8e9d1.jpg";